// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"d5582b39","441":"e021f8e3","875":"b37fad64"}[chunkId] + ".chunk.js";
};